import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionEquipment, constructionSafety } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

export default {
  desc: 'Hệ thống Smart Parking (Bãi giữ xe thông minh) là một không gian đỗ xe sử dụng công nghệ và hạ tầng tiên tiến để giải quyết vấn đề đỗ xe và quản lý đỗ xe hiệu quả trong môi trường đô thị hiện đại.',
  keywords: 'Smart Parking, Bãi đỗ xe thông minh, Bai do xe thong minh, Quản lý đỗ xe, Quan ly do xe, Trạm dừng nghỉ, Tram dung nghi, Digital Twin\n',
  ogSite: 'Hệ thống Bãi giữ xe thông minh (Smart Parking)',
  title: 'Hệ thống Bãi giữ xe thông minh (Smart Parking)',
  ogUrl: 'https://orbro.io/vi/blog/smart-parking',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmD7VPkEf-FilCFjgoS9bLoX8jzIaaMktsjySXAPNjEeeFagK2_315Sl39yXx7L8iamkUCasZgYN_nmqjEzlcJ7b471GwtTQQuGwwOAfQQA6S8NE3asVOx8onF2HoacQcQFEPQ8CAhcl0rNpbh8bBS8FFHY4_D2fvH08mJkm9qWDYYAV69cnY6EoN7AbjCxcmjDp9MRJWdjSZLXFzgpaIIYwkOai0qq4fv00oAK7nW5aHmjQ7yW3Fs_dnUPcWjO02-SJvPDSXNRfqALw7R8fQ1xzAouT41STdr9FL0nvwawirXEQrJHdFYmtKxTMeYwrzrbvapEVr_9gbwWf7Xz6op2cCCQ9rlTypNRAUcoImxb8moTg_z4h0lB4He17_bFIKP8htIGOonJQ30cdXaym4saPjQhyRCio1wMUVwgbmNVC3b4zyJ5L9HnxyCsxDiVEDthb0FhoiTe75C-fAaLDxkhVfyjQTSX7lCYYG_JjPfTEo2kBb6fU79VYeUO4Kb_eWYiPR2Iwfzuu7StZDg_fEldXXzjVx6NJPi6R4a0r8VwuTtEwURqugwI57tg0kMwc1CN3P6SfBrzGPldfU6D5kntEPrH4rZvGkFLUOhGrKJWQrBodIb2rV5aACulW8o5W5D8wDEJkfyNS-F0oQHBEqzp9nZxKDuGMZ2gb_1rBuvwbphoql1q_W42SNGRTzjK3yZLzxxh9utXyY4bL4KVGrSVYX5BrshF1Uxy9qzyfmgNeI_sy5Tbah5GI3QhJG_MWU8nN5WicgsNpOWRVNSKyEhrt5hUOE5AVc60roL6Ar04TIJvjwBc85d0W_DonnbugsHZd-ZE2a1qACGExoN1GoO7gY8I0rGyaeXPXmz-eKFBYlni7VNvL_-WZlVfON20nmmnJGjJENADAWpBqdcJsKErZNryomDdplCibc53ZnYZ0-tE14kXFvQSMVx9rpq7xNi459vviazTPO_ZP6OKfTXX6tIrYW-vNA6r-vVM2nvber10dIqepSAUGPhm85RXyKGyHzU2sMQZA_0KKZR9ghdnDbzKyk6Ig0gcSclnaKoUAv0tV8ouS-IML_FSjTylgxNCHCeh5DRwimnmWs-M-Qj8E_pvYxpE5gDx5NFgO3KQtnEk7ZocAEpOSVFN5PHfWUhpTh-ZsM4joGNhdAiBAbc-VZzDs0jIIC2xpKDPdpUtVvIaVM9X_lf5FKcKd7VLx27m6hSL2bmbgdvx4t33C6fN69eGruOV7uvS1-K7vO6dqs-g4FWmrLDnOFmCGDyaa8gwvxozpfxaSUqklsYGSVuw6zCnAgAM-z6ApVjVb6P_aRbWW4ETJnzuMg3O4RVMoQZ1XGTM2kXC_0Um42ueBxfKmL7cAdcHi77Mxu7jLWBKoR1MI0uR-Flk-ouBsLn0joMzdQK6d3noiwmXVnNt26nLyiTY0OuyNhP5oDp6lXYyWjUsUwSZs2GpTcNDljddjYs1m1T7ckdu_JHlFsHpJ3RYQxuOcSAHdB4sv4hQohcrrbkctCpfLF8KUHAI4LbX1RqQ8eHJfD1wKMUSd7CydiQFcKD7FLnz=w1501-h1172',
  ogType: 'website',
  date: '2024-01-24',
  tag1: '#SmartParking',
  tag2: '#Baidoxethongminh',
  tag3: '#Quanlydoxe',
  tag4: '#Tramdungnghi',
  text: [
    {
      head: 'Hệ thống Smart Parking',
      subHead: '',
      desc: 'Hệ thống Smart Parking (Bãi giữ xe thông minh) là một không gian đỗ xe sử dụng công nghệ và hạ tầng tiên tiến để giải quyết vấn đề đỗ xe và quản lý đỗ xe hiệu quả trong môi trường đô thị hiện đại. Các bãi đỗ xe này tích hợp nhiều yếu tố công nghệ khác nhau nhằm tối ưu hóa quy trình đỗ xe và mang lại trải nghiệm tiện lợi hơn cho người sử dụng xe.\nĐể có hệ thống như vậy, cần áp dụng công nghệ Digital Twin để tạo ra một màn hình kỹ thuật số giống hệt với hình ảnh bãi đỗ xe thực tế và truyền dữ liệu. Dưới đây là các đặc điểm và chức năng chính của Smart Parking:',
      dot: '',
    },
    {
      head: 'Các tính năng của Smart Parking',
      subHead: '',
      desc: 'Hệ thống Smart Parking cung cấp nhiều chức năng khác nhau nhằm cải thiện quản lý đỗ xe và trải nghiệm người dùng bằng cách sử dụng các công nghệ tiên tiến. Các chức năng này mang lại lợi ích cho cả nhà quản lý bãi đỗ xe và người sử dụng xe, đồng thời giúp giải quyết các vấn đề đỗ xe trong thành phố. Dưới đây là danh sách các chức năng chính thường được cung cấp trong Smart Parking:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Theo dõi vị trí theo thời gian thực',
      desc: 'Sử dụng camera AI, cảm biến và công nghệ IoT để theo dõi và quản lý vị trí của xe trong bãi đỗ xe theo thời gian thực. Điều này giúp nhanh chóng xác định các chỗ đỗ xe trống.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hướng dẫn đỗ xe',
      desc: 'Hướng dẫn vị trí chỗ đỗ xe trống cho người dùng thông qua ứng dụng di động hoặc màn hình hiển thị, giúp việc đỗ xe trở nên dễ dàng hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Đặt chỗ đỗ xe',
      desc: 'Người dùng có thể đặt chỗ đỗ xe từ xa và đảm bảo có chỗ đỗ xe trước khi đến.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích lưu lượng người dùng',
      desc: 'Sử dụng cảm biến và camera bên trong bãi đỗ xe để phân tích thời gian nào bãi đỗ xe đông đúc nhất và cung cấp thông tin này cho người dùng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nhận diện biển số xe',
      desc: 'Nhận diện biển số xe để tự động phát hiện và quản lý việc đỗ xe trái phép, quá giờ đỗ xe và các vi phạm khác.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Bảo mật và An toàn',
      desc: 'Lắp đặt camera CCTV và cảm biến bên trong bãi đỗ xe để tăng cường an toàn cho xe và khu vực đỗ xe.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích dữ liệu và Tối ưu hóa',
      desc: 'Phân tích dữ liệu thu thập được để tối ưu hóa vận hành bãi đỗ xe và tìm ra các điểm cải tiến. Thông qua đó, nhà quản lý bãi đỗ xe có thể sử dụng tài nguyên hiệu quả.',
      dot: '',
    },
    {
      head: 'Công nghệ Smart Parking',
      subHead: 'Camera AI và Công nghệ Thị giác máy tính',
      desc: 'Camera AI là hệ thống camera dựa trên công nghệ thị giác máy tính tiên tiến. Chúng được sử dụng để giám sát và phân tích tất cả các hoạt động trong bãi đỗ xe. Ví dụ, chúng có thể phát hiện và nhận diện biển số xe, loại và màu xe, vị trí và hướng di chuyển của xe theo thời gian thực. Thông tin này được sử dụng để tối ưu hóa vận hành bãi đỗ xe và cung cấp thông tin đỗ xe cho người sử dụng xe. Đồng thời, chúng cũng được dùng để xác định và quản lý việc đỗ xe trái phép hoặc các vi phạm khác.',
      dot: '',
    },
    {
      head: '',
      subHead: 'IoT (Internet vạn vật)',
      desc: 'IoT là công nghệ thu thập và truyền dữ liệu thông qua các cảm biến và thiết bị khác nhau được lắp đặt trong bãi đỗ xe. Các cảm biến thu thập nhiều thông tin khác nhau như sự di chuyển của xe, tình trạng chỗ đỗ xe có sẵn, nhiệt độ, độ ẩm bên trong bãi đỗ xe theo thời gian thực. Thông tin này được sử dụng trong việc vận hành và quản lý bãi đỗ xe, đồng thời giám sát và phân tích trạng thái của bãi đỗ xe để cung cấp một môi trường đỗ xe tiện lợi cho người sử dụng xe.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ứng dụng di động và Dịch vụ Web',
      desc: 'Ứng dụng di động và dịch vụ web được sử dụng để cung cấp thông tin đỗ xe cho người sử dụng xe và quản lý quy trình đỗ xe. Người dùng có thể kiểm tra vị trí chỗ đỗ xe trống và đặt chỗ thông qua ứng dụng di động. Ngoài ra, họ có thể thanh toán phí đỗ xe và giám sát trạng thái đỗ xe. Bên cạnh đó, thông qua dịch vụ web, người dùng cũng có thể kiểm tra và quản lý thông tin đỗ xe trên trình duyệt máy tính, mang lại nhiều tiện ích đa dạng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích Big Data',
      desc: 'Phân tích Big Data là quá trình phân tích chuyên sâu lượng lớn dữ liệu được thu thập từ Smart Parking. Dữ liệu thu thập được phân tích từ nhiều khía cạnh khác nhau như mô hình hành vi của người sử dụng xe, mức độ tắc nghẽn trong bãi đỗ xe, hiệu quả của chính sách phí đỗ xe.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tối ưu hóa vận hành bãi đỗ xe:',
      desc: 'Tối ưu hóa thời gian vận hành, bố trí chỗ đỗ xe, chính sách phí đỗ xe, v.v., để nâng cao hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao trải nghiệm người dùng',
      desc: 'Hiểu được hành vi của người dùng và dựa trên đó cải thiện quy trình đỗ xe để nâng cao trải nghiệm người dùng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường doanh thu',
      desc: 'Thông qua phân tích Big Data, tối ưu hóa chính sách phí đỗ xe và tìm kiếm các phương pháp để tăng cường doanh thu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phát triển mô hình dự đoán',
      desc: 'Phát triển các mô hình dự đoán tình trạng chỗ đỗ xe có sẵn, nhu cầu đỗ xe, v.v., trong tương lai thông qua phân tích dữ liệu để lập kế hoạch vận hành.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Xác định và ứng phó với vấn đề',
      desc: 'Xác định các vấn đề trong bãi đỗ xe thông qua phân tích dữ liệu và thực hiện các biện pháp ứng phó nhanh chóng. Ví dụ, có thể phân bổ thêm chỗ đỗ xe để ngăn chặn tình trạng tắc nghẽn trong bãi đỗ xe.',
      dot: '',
    },
    {
      head: 'Các trường hợp ứng dụng Smart Parking',
      subHead: 'Trạm dừng nghỉ Hàn Quốc - Quản lý bãi đỗ xe sử dụng Beacon',
      desc: 'Một số bãi đỗ xe tại Hàn Quốc đang vận hành Smart Parking bằng cách sử dụng công nghệ Beacon. Beacon liên kết với ứng dụng di động để cung cấp thông tin về chỗ đỗ xe trống theo thời gian thực, đồng thời nhận diện xe trong bãi đỗ xe để quản lý việc ra vào. Ngoài ra, nó còn giúp người dùng nhận thông tin đỗ xe qua ứng dụng di động và xử lý thanh toán một cách tiện lợi.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Los Angeles, Hoa Kỳ - Cung cấp thông tin đỗ xe theo thời gian thực',
      desc: 'Los Angeles đang xây dựng Smart Parking và vận hành dịch vụ cung cấp thông tin đỗ xe theo thời gian thực nhằm giải quyết vấn đề đỗ xe ở khu vực trung tâm thành phố. Thông qua dịch vụ này, người lái xe có thể kiểm tra vị trí chỗ đỗ xe trống và thông tin phí đỗ xe trên ứng dụng di động, giúp việc sử dụng bãi đỗ xe trở nên tiện lợi hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thượng Hải, Trung Quốc - Robot đỗ xe tự hành',
      desc: 'Một số bãi đỗ xe tại Thượng Hải đã áp dụng robot đỗ xe tự hành, sử dụng công nghệ tự động đưa xe vào chỗ đỗ và tìm kiếm xe. Người lái xe có thể sử dụng hệ thống robot chỉ bằng cách để xe ở lối vào bãi đỗ xe, từ đó rút ngắn thời gian đỗ xe và cảm thấy tiện lợi hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tokyo, Nhật Bản - Thanh toán phí đỗ xe tự động',
      desc: 'Một số bãi đỗ xe tại Tokyo tự động tính toán và thanh toán phí đỗ xe thông qua công nghệ nhận diện biển số xe và ứng dụng di động. Điều này giúp người lái xe có thể nhanh chóng rời khỏi bãi đỗ xe, giảm bớt sự rắc rối khi thanh toán bằng tiền mặt hoặc thẻ tín dụng.',
      dot: '',
    },
    {
      head: 'Triển vọng phát triển của Smart Parking',
      subHead: '',
      desc: 'Trong tương lai, Smart Parking dự kiến sẽ đóng vai trò quan trọng hơn nữa, tích hợp với phương tiện tự hành để tối ưu hóa quy trình đỗ xe và tận dụng chức năng đỗ xe tự động. Ngoài ra, sự phát triển của công nghệ truyền thông dữ liệu tốc độ cao sẽ giúp việc chia sẻ dữ liệu theo thời gian thực dễ dàng hơn, và công nghệ Machine Learning cùng Trí tuệ nhân tạo (AI) sẽ cải thiện khả năng dự đoán chỗ đỗ xe và phân tích mô hình người dùng.\nSmart Parking sẽ được tích hợp vào các dự án Smart City, trở thành thành phần cốt lõi để quản lý và điều tiết giao thông, đồng thời dữ liệu đỗ xe sẽ được sử dụng trong quy hoạch đô thị và quản lý ùn tắc giao thông. Công nghệ bảo mật cũng được kỳ vọng sẽ được tăng cường hơn nữa, đóng vai trò lớn trong việc đảm bảo an toàn cho xe cộ và cơ sở vật chất trong bãi đỗ xe',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
